import { render } from "./PlayerGroupChat.vue?vue&type=template&id=6c6a13e2&scoped=true&ts=true"
import script from "./PlayerGroupChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerGroupChat.vue?vue&type=script&setup=true&lang=ts"

import "./PlayerGroupChat.vue?vue&type=style&index=0&id=6c6a13e2&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6a13e2"],['__file',"src/views/player/PlayerGroupChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c6a13e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c6a13e2', __exports__)) {
    console.log('reload')
    api.reload('6c6a13e2', __exports__)
  }
  
  module.hot.accept("./PlayerGroupChat.vue?vue&type=template&id=6c6a13e2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6c6a13e2', render)
  })

}


export default __exports__